import MuiCheckbox, { type CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import { type ComponentType, type ForwardedRef, forwardRef, type JSX } from 'react';
import { type AppearanceProps, CheckboxAppearance } from './CheckboxAppearance';

export type MuiCheckboxWithErrorProps = MuiCheckboxProps & {
  isError?: boolean;
  Appearance?: ComponentType<AppearanceProps>;
};

export const Checkbox = forwardRef(
  (
    { Appearance = CheckboxAppearance, ...props }: MuiCheckboxWithErrorProps,
    ref: ForwardedRef<HTMLButtonElement>
  ): JSX.Element => {
    const { isError, ...rest } = props;

    return (
      <MuiCheckbox
        color={isError ? 'error' : 'primary'}
        checkedIcon={
          <Appearance isChecked={true} isDisabled={!!rest.disabled} isIndeterminate={false} isError={!!isError} />
        }
        indeterminateIcon={
          <Appearance isChecked={false} isDisabled={!!rest.disabled} isIndeterminate={true} isError={!!isError} />
        }
        icon={<Appearance isChecked={false} isDisabled={!!rest.disabled} isIndeterminate={false} isError={!!isError} />}
        ref={ref}
        {...rest}
      />
    );
  }
);
